module.exports = __webpack_public_path__ + "img/323.35be4132.png";